import { z } from 'zod';

// ---------------------------------------------------------------------------
// Workflow status — the normalised, provider-agnostic "pipeline stage" a work
// item sits in, unifying a GitHub PR's draft/review/merge state, a GitHub
// issue's open/closed, and a Linear issue's workflow-state type. It is a derived
// projection (computed at the consolidation boundary by `deriveWorkflow`), kept
// distinct from the existing `state` (`open|closed|merged`) and the `status` URL
// filter, which both still mean the binary merge state.
// ---------------------------------------------------------------------------

/**
 * The statuses in attention/pipeline order: backlog → being worked → in review
 * → resolved. The work-items "group by workflow" mode renders columns in this
 * order, and the MCP surface treats it as canonical.
 */
export const WORKFLOW_STATUSES = [
  'triage',
  'todo',
  'in_progress',
  'in_review',
  'changes_requested',
  'approved',
  'done',
  'cancelled',
] as const;

export const WorkflowStatusSchema = z.enum(WORKFLOW_STATUSES);
export type WorkflowStatus = z.infer<typeof WorkflowStatusSchema>;
